import { Game, GameCard, GamePurchaseOffer } from './types';

type DiscountedPrice = Pick<GamePurchaseOffer, 'price' | 'discountPercent' | 'discountEndsAt'>;

export const hasActiveDiscount = (item: DiscountedPrice | GameCard) => Boolean(
  item.discountPercent &&
  (!item.discountEndsAt || new Date(item.discountEndsAt).getTime() > Date.now()),
);

export const originalPrice = (item: DiscountedPrice | GameCard): number | null => {
  if (!hasActiveDiscount(item)) return null;
  const percent = item.discountPercent ?? 0;
  return percent > 0 && percent < 100
    ? Math.round(item.price / (1 - percent / 100))
    : null;
};

export const cheapestRegionalOffer = (game: Game): GamePurchaseOffer | undefined =>
  (game.purchaseOffers ?? [])
    .filter(offer =>
      offer.isAvailable &&
      offer.fulfillmentType === 'PersonalPurchase' &&
      (offer.region === 'India' || offer.region === 'Turkey'))
    .sort((a, b) => a.price - b.price)[0];
